<template>
  <g-popup v-bind="$props" title="비밀번호 초기화"  :background-click="false">
    <template #body>
      <div class="-font-size-12">
        <h3 class="-mb-5 -h3 -font-weight-regular">
          고객님의 요청에 의한 비밀번호 초기화를 위해 Customer Portal에서 사용한 이메일을 입력해 주세요.
        </h3>
        <div class="-label -width-100">
          <div class="-wrapper">
            <p class="-text">이름</p>
            <p class="-color-blue-1 -ml-1 -mt-1">*</p>
          </div>
          <input type="text" class="-input -width-100" placeholder="Placeholder">
        </div>
      </div>
    </template>
    <template #footer>
      <button class="-btn primary- -mr-0" type="submit">
        <span>확인</span>
      </button>
    </template>
  </g-popup>
</template>

<script>
  export default {
    name: 'login-reset-password-popup',
    componentName: 'LoginResetPasswordPopup',
    props: ['width']
  }

</script>



// WEBPACK FOOTER //
// src/pages/login/components/LoginResetPasswordPopup.vue